import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/api.service";
import { GetOpsService } from "../../services/get_ops/get-ops.service";

@Component({
  selector: 'app-editar-sol',
  templateUrl: './editar-sol.component.html',
  styleUrls: ['./editar-sol.component.scss'],
})

export class EditarSolComponent implements OnInit {

  constructor(
    public api: ApiService,
    public ops: GetOpsService
  ) { }

  ngOnInit() { }
  
  async cambiarSolicitudApi(){
    console.log("soliitud: ",this.api.solEdit);
    console.log("New estado:", this.api.editEstadoValue);
    let item = this.api.estados.findIndex(est => est.Descripcion == this.api.editEstadoValue);
    let IdEstado = this.api.estados[item].IdEstado;

    console.log('IdEstado: ',IdEstado);
    console.log('New Sol. Reperf.: ',this.api.solReperfilado)

    if (IdEstado == 9 || IdEstado == 11) {
      console.log('Cambiando estado...');

      const body = {
        numsol:this.api.solEdit.NumSol,
        newidestado:IdEstado,
        newsol:this.api.solReperfilado
      };
      
      await this.api.req('post', 'changeestadosol', body, 'Cambiando estado...').then( async (res:any) => {
        console.log('cambiarSolicitudApi res: ',res);
        
        // this.ops.getRunCredits2();
        await this.api.popoverController.dismiss({
          refresh: true,
          cedula: this.api.solEdit.Cedula?.trim()
        });
      }).catch((err) => {
        this.api.presentAlert('Error', 'Al cambiar estado de solicitud', JSON.stringify(err));
      })
    } else if (IdEstado == 10){
      console.log('pagoAntValue: ',this.api.pagoAntValue);
      console.log('usuario: ',this.api.user.Usuario);
      console.log('Cambiando estado...');

      const body = {
        numsol:this.api.solEdit.NumSol,
        saldok:this.api.pagoAntValue.saldok,
        intereses:this.api.pagoAntValue.intereses,
        cloud:this.api.pagoAntValue.cloud,
        seguro:this.api.pagoAntValue.seguro,
        fecha:this.api.pagoAntValue.fechapago,
        usuario:this.api.user.Usuario,
        diasinteres:this.api.pagoAntValue.diasinteres,
      };
      
      await this.api.req('post', 'pagoant', body, 'Cambiando estado...').then( async (res:any) => {
        console.log('cambiarSolicitudApi res: ',res);
        
        // this.ops.getRunCredits2();
        await this.api.popoverController.dismiss({
          refresh: true,
          cedula: this.api.solEdit.Cedula?.trim()
        });
      }).catch((err) => {
        this.api.presentAlert('Error', 'Al cambiar estado de solicitud', JSON.stringify(err));
      })
    } else {
      this.api.presentAlert('Alerta', 'Solicitud denegada', '');
    }
  }
}